<template lang="html">
  <div ref="curator" @click="show = !show"  class="aha-row clickable">
    <p :class="{ show: show, fold: english }" v-html="post.title"></p>
    <div class="read-more" v-if="show">
      <img v-if="post.files.length > 0" :src="post.files[0].url" :alt="post.title" />
      <div class="more-text small" v-html="post.text"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Organiser',
  props: {
    post: Object
  },
  data() {
    return {
      show: false,
      english: true
    }
  },
  created() {
    if (this.$route.name === 'english') {
      this.english = true
    }
    // window.addEventListener('scroll', this.inViewport)
  },
  destroyed() {
    // window.removeEventListener('scroll', this.inViewport)
  },
  methods: {
    inViewport() {
      let hW = window.innerHeight / 2
      let center = window.scrollY + hW
      let top = this.$refs.curator.offsetTop - 4
      let height = top + this.$refs.curator.clientHeight + 4
      if (center > top && center < height) {
        this.$refs.curator.classList.add('active')
      } else {
        this.$refs.curator.classList.remove('active')
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
.read-more {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}
.click,
.fold {
    // &:hover {
    cursor: pointer;
    // color: grey;
    // }
}
.more-text.small p {
    margin-bottom: $gap / 3;
    &:last-child {
        margin-bottom: 0;
    }
    @media only screen and (min-width:600px) {
        font-size: $font-size / 3;
        line-height: 1.15;
    }
    a {
        &.router-link-exact-active,
        &:hover {
            &:before {
                content: '';
                position: absolute;
                width: 100%;
                border-bottom: 2px solid $font-color;
                @media only screen and (max-width: $phone) {
                    border-bottom: 1px solid $font-color;
                }
                bottom: 0.2rem;

            }
        }
    }
}
</style>
